import { axiosInstance } from "@/api/apiClient";
import {
  SalesCampaignApi,
  SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentCallQueueInCampaignRequest,
  SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentCallQueueItemsInCampaignRequest,
  SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentRankingsAcrossCampaignsRequest,
  SalesCampaignApiAddonsViewsNinjaSalesCampaignListActiveAgentCampaignsMinimalRequest,
  SalesCampaignApiAddonsViewsNinjaSalesCampaignListAgentCallQueuesAcrossCampaignsRequest,
  SalesCampaignApiAddonsViewsNinjaSalesCampaignRetrieveAgentCampaignRequest,
} from "@/api/client";
import { BASE_API } from "@/helpers/constants";

const api = new SalesCampaignApi(undefined, BASE_API, axiosInstance);

export const getAgentCallQueueAcrossCampaigns = async (
  payload: SalesCampaignApiAddonsViewsNinjaSalesCampaignListAgentCallQueuesAcrossCampaignsRequest
) => {
  return api.addonsViewsNinjaSalesCampaignListAgentCallQueuesAcrossCampaigns.bind(
    api
  )(payload);
};

export const getAgentCallQueueInCampaign = async (
  payload: SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentCallQueueInCampaignRequest
) => {
  return api.addonsViewsNinjaSalesCampaignGetAgentCallQueueInCampaign.bind(api)(
    payload
  );
};

export const getAgentCallQueueItemsInCampaign = async (
  payload: SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentCallQueueItemsInCampaignRequest
) => {
  return api.addonsViewsNinjaSalesCampaignGetAgentCallQueueItemsInCampaign.bind(
    api
  )(payload);
};

export const getActiveAgentCampaignsMinimal = async (
  payload: SalesCampaignApiAddonsViewsNinjaSalesCampaignListActiveAgentCampaignsMinimalRequest
) => {
  return api.addonsViewsNinjaSalesCampaignListActiveAgentCampaignsMinimal.bind(
    api
  )(payload);
};

export const getAgentCampaign = async (
  payload: SalesCampaignApiAddonsViewsNinjaSalesCampaignRetrieveAgentCampaignRequest
) => {
  return api.addonsViewsNinjaSalesCampaignRetrieveAgentCampaign.bind(api)(
    payload
  );
};

export const getAgentRankingsAcrossCampaigns = async (
  payload: SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentRankingsAcrossCampaignsRequest
) => {
  return api.addonsViewsNinjaSalesCampaignGetAgentRankingsAcrossCampaigns.bind(
    api
  )(payload);
};
